import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { green, yellow, red, grey } from '@material-ui/core/colors';
// import DialogOptions from '../Complements/DialogOptions';


// import PaymentTrayItem from './PaymentTrayItem';

const columns = [
    { id: 'checked', label: 'Estado', minWidth: 170 },
    { id: 'names', label: 'Solicitante', minWidth: 170 },
    { id: 'date', label: 'Fecha de cobro', minWidth: 170 },
    { id: 'description', label: 'Descripcion', minWidth: 100 },
  ];

const CheckbookTray = props => {
    const { classes, paymentsData, handleOpenDialog, typeRequest } = props
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const renderIcon = (title, color, icon) => {
        return (
            <Tooltip title = { title } placement="top-start">
                <Icon style={{ color }} fontSize="large">{ icon }</Icon>
            </Tooltip>
        )
    }

    const openDialog = (data) => {
        (data.checked !== 1) &&
        handleOpenDialog(data);
    };
    return (
        <div>
            <Paper className={classes.root}>
                <div className={classes.tableWrapper}>
                    <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                        {columns.map(column => {
                            if (typeRequest === 'Charge' && column.label === 'Solicitante') {
                                column.label = 'Emitido a'
                            }
                            return <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                                >
                                <b>{column.label}</b>
                            </TableCell>
                        })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { paymentsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(Data => {
                        return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={Data.id} onClick={ () => { openDialog(Data) }}>
                            {columns.map(column => {
                                let value = Data[column.id];
                                if (column.id === 'names') {
                                    if (typeRequest === 'Payment') {
                                        value = `${Data.Emitidor.first_name} ${Data.Emitidor.second_name} ${Data.Emitidor.surname} ${Data.Emitidor.second_surname}`
                                    } else if ( typeRequest === 'Charge') {
                                        value = `${Data.Solicitado.first_name} ${Data.Solicitado.second_name} ${Data.Solicitado.surname} ${Data.Solicitado.second_surname}`
                                    }
                                }

                                if (column.id === 'checked' ) {
                                    switch (Data.state ) {
                                        case "1":
                                            value = renderIcon('Cheque cobrado', green[500], 'check_circle')
                                            break;
                                        case '2':
                                            // value = 'Pagado'
                                            value = renderIcon('Este cheque ha sido endosado', red[700], 'clear')
                                            break;
                                        case '3':
                                            value = renderIcon('Cheque pendiente de cobro (endosado)', red[700], 'clear')
                                            break;
                                        case '4':
                                            value = renderIcon('Esta cheque ha sido cancelado', grey[900], 'clear')
                                            break;
                                        default:
                                            value = renderIcon('Cheque pendiente de cobro', yellow[700], 'schedule')
                                            break;
                                    }
                                }
                                    
                                return (
                                <TableCell key={column.id} align={column.align} >
                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                </TableCell>
                                );
                            })}
                            </TableRow>
                        );
                        })}
                    </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={paymentsData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                    'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                    'aria-label': 'next page',
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
            {
                /* paymentsData.map( data =>
                    <PaymentTrayItem
                    />
                ) */
            }
        </div>
    );
};

CheckbookTray.propTypes = {
    paymentsData: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    typeRequest: PropTypes.string.isRequired,
};

export default CheckbookTray;